export interface Tenant {
    uuid: string;
    name: string;
    id?: string; // For backward compatibility
}

export interface Environment {
    api: {
        baseUrl: string;
    };
}

// Simple environment-based API base URL
const getApiBaseUrl = (): string => {
    // VITE_API_URL takes precedence (CI, integration tests, custom backend host)
    if (import.meta.env.VITE_API_URL) {
        return import.meta.env.VITE_API_URL;
    }
    // In development, use relative URL so the Vite proxy forwards /api and /auth
    // to the configured backend (see vite.config.ts). Avoids CORS.
    if (import.meta.env.MODE === 'development') {
        return '';
    }
    // Production: same origin as frontend (nginx proxies to backend)
    return window.location.origin;
};

// Lazy initialization to avoid TDZ issues
let environmentCache: Environment | null = null;

export function getEnvironment(): Environment {
    if (!environmentCache) {
        environmentCache = {
            api: {
                baseUrl: getApiBaseUrl(),
            }
        };
    }
    return environmentCache;
}

// REMOVED: environment export to avoid TDZ issues
// The environment constant was causing TDZ (Temporal Dead Zone) errors when
// dynamically imported. Use getEnvironment() function instead.
// 
// If you need backward compatibility, you can create a getter:
// export const environment = { get api() { return getEnvironment().api; } };
// But this still causes issues, so we removed it completely.
// 
// Use getEnvironment() function instead of environment constant.

export function getSelectedTenant(): Tenant | null {
    // Get from localStorage
    const storedTenant = localStorage.getItem('selectedTenant');

    if (storedTenant) {
        const tenant = JSON.parse(storedTenant);

        // Handle both old 'id' field and new 'uuid' field
        if (tenant.uuid || tenant.id) {
            return {
                uuid: tenant.uuid || tenant.id,
                name: tenant.name
            };
        }
    }

    return null;
}

export function setSelectedTenant(tenant: Tenant): void {
    localStorage.setItem('selectedTenant', JSON.stringify(tenant));
} 